<div class="desktop edp-card-widget card">
    <div class="card-header">
        <span class="card-title">{{ 'pt.edp.edponline.health.title' | translate }}</span>
        <span class="card-icon">
            <i class="icon-edponline-Bop-091"  aria-hidden="true"></i>
        </span>
    </div>
    <div class="card-body">

        <span class="icon-health">
            <i class="icon-edponline-Bra-052"  aria-hidden="true"></i>
        </span>
        <span class="description">{{ 'pt.edp.edponline.health.description' | translate }}</span>
        <a class="link" href="{{ 'pt.edp.edponline.health.link' | translate }}" [edpExternalLink]="'pt.edp.edponline.health.link' | translate"><span>{{ 'pt.edp.edponline.health.link.text' | translate }}<i class="icon-edponline-EDP_Online_09"  aria-hidden="true"></i></span></a>
    </div>
</div>

<!-- MOBILE -->
<div class="mobile edp-card-widget card">
    <div class="card-header">
        <span class="card-title-small">{{ 'pt.edp.edponline.health.title' | translate }}</span>
        <span class="card-icon">
            <i class="icon-edponline-Bop-091"  aria-hidden="true"></i>
        </span>
    </div>
    <div class="card-body">
        <div class="description-mobile" [innerHTML]="'pt.edp.edponline.health.mobile.description' | translate"></div>
    </div>
</div>
